/** On-chain Mint Lab custody wallet (matches backend default). */
export const MINT_LAB_CUSTODY_WALLET = '0x0d7cee770ab099b700e2cbb92bf1b27e2738edd9'

export function normalizeWalletAddress(wallet) {
  return String(wallet || '')
    .trim()
    .toLowerCase()
}

export function isMintLabCustodyWallet(wallet) {
  return normalizeWalletAddress(wallet) === normalizeWalletAddress(MINT_LAB_CUSTODY_WALLET)
}

/** Portal-only custody transfer (no wallet handoff for the owner). */
export function isPortalCustodyTransferRequest(request) {
  if (!request || typeof request !== 'object') return false
  if (request.beneficiary?.id || request.beneficiaryUserId) return true
  return isMintLabCustodyWallet(request.newOwnerWallet)
}
